import { render } from "./SettingsComponent.vue?vue&type=template&id=0671fd52&scoped=true"
import script from "./SettingsComponent.vue?vue&type=script&lang=js"
export * from "./SettingsComponent.vue?vue&type=script&lang=js"

import "./SettingsComponent.vue?vue&type=style&index=0&id=0671fd52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0671fd52"]])

export default __exports__